import { render, staticRenderFns } from "./iframeloader.vue?vue&type=template&id=7bb93167&"
import script from "./iframeloader.vue?vue&type=script&lang=js&"
export * from "./iframeloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "output/iframeloader.vue"
export default component.exports